import _defineProperty from "/var/www/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var __jsx = React.createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable consistent-return */
import React, { useState } from 'react';
// import { useQuery } from '@apollo/client';
// import { useRouter } from 'next/router';
import Grid from '@mui/material/Grid';
import { Divider, Box, Fab } from '@mui/material';
import RoomIcon from '@mui/icons-material/Room';
import LanguageIcon from '@mui/icons-material/Language';
import PublicIcon from '@mui/icons-material/Public';
import LibraryMusicIcon from '@mui/icons-material/LibraryMusic';
import AssignmentTurnedInOutlinedIcon from '@mui/icons-material/AssignmentTurnedInOutlined';
import InstagramIcon from '@mui/icons-material/Instagram';
import TwitterIcon from '@mui/icons-material/Twitter';
import FacebookIcon from '@mui/icons-material/Facebook';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
// import Container from '@material-ui/core/Container';
import Skeleton from '@mui/lab/Skeleton';
import AccessAlarmsIcon from '@mui/icons-material/AccessAlarms';
// import LocationOnIcon from '@material-ui/icons/LocationOn';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import moment from 'moment';
import Typography from '@atoms/Typography';
import Spacer from '@atoms/Spacer';
import ImageLightbox from '@molecules/ImageLightbox';
import OpportunityFee from '@molecules/OpportunityFee';
import Link from '@atoms/Link';
import { dateTimeVisibilityHandler } from '@app/helpers/dateVisibilityHandler';
import { capitalize, redirectToRoute } from '@app/helpers';
import VideoItem from '@molecules/VideoLink/VideoItem';
import { OPP_STATUS_ENUM } from '@app/constants';
import { FacebookShareButton, InstapaperShareButton, TwitterShareButton, LinkedinShareButton } from 'react-share';
import VideoSlider from '../../common/VideoSlider';
import Card from '../../../atoms/Card';
import { OpportunityMeta, ActionsContainer, ChipsContainer, BodyText, SectionDivider, OrgAvatar, LogoContainer, StyledChip, DedaLine, ShareBox } from './style';
import { useTranslation, i18n } from '../../../../config/i18n';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var getImagesArray = function getImagesArray(images, attr) {
  return images.map(function (image) {
    return image[attr];
  });
};
var ViewOpportunity = function ViewOpportunity(_ref) {
  var _opportunity$time_vis, _opportunity$experien;
  var slug = _ref.slug,
    opportunity = _ref.opportunity,
    loading = _ref.loading;
  var _useTranslation = useTranslation('wizard', 'dashboard', 'common', 'organisations'),
    t = _useTranslation.t;
  var applyPageHandler = function applyPageHandler() {
    redirectToRoute({}, 'form_viewer', {
      params: {
        slug: slug
      }
    });
  };
  var _useState = useState(false),
    isMobile = _useState[0],
    setIsMobile = _useState[1];
  var _useState2 = useState(true),
    isAvailableFees = _useState2[0],
    setIsAvailableFees = _useState2[1];
  React.useEffect(function () {
    if (opportunity && opportunity.payment_details && opportunity.slots_status) {
      opportunity.payment_details.forEach(function (payment) {
        opportunity.slots_status.forEach(function (slot) {
          if (payment.code === slot.code) {
            if (payment.slots <= slot.slots) {
              setIsAvailableFees(false);
            } else {
              setIsAvailableFees(true);
              return true;
            }
          } else {
            setIsAvailableFees(true);
          }
        });
      });
    }
  }, []);
  var userCanApply = function userCanApply() {
    var isAvailable = opportunity && opportunity.form && !opportunity.form.is_skipped;
    if (opportunity.deadline_date) {
      isAvailable = isAvailable && moment(opportunity.deadline_date).diff(moment()) > 0;
    } else if (!opportunity.deadline_date && opportunity.start_date) {
      isAvailable = isAvailable && moment(opportunity.start_date).diff(moment()) > 0;
    }

    // return userInfo && isAvailable;

    return isAvailable;
  };
  React.useEffect(function () {
    if (window.innerWidth < 600) {
      setIsMobile(true);
    }
  }, []);
  var formatExperienceLevel = function formatExperienceLevel(experienceLevel) {
    if (Array.isArray(experienceLevel)) {
      return experienceLevel.map(function (level) {
        return t(level.toLowerCase());
      }).join(', ');
    }
    if (typeof experienceLevel === 'string') {
      return t(experienceLevel.toLowerCase());
    }
    return '';
  };
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsxs(Card, {
      children: [/*#__PURE__*/_jsxs(BodyText, {
        children: [/*#__PURE__*/_jsx(Spacer, {
          height: "3rem"
        }), opportunity.start_date && dateTimeVisibilityHandler(opportunity, 'h6', 'secondary'), loading ? /*#__PURE__*/_jsx(Box, {
          width: "40%",
          marginBottom: "1.4rem",
          children: /*#__PURE__*/_jsx(Skeleton, {
            animation: "wave",
            variant: "rect",
            height: 40,
            width: "100%"
          })
        }) : /*#__PURE__*/_jsx(Typography, {
          variant: "h2",
          gutterBottom: true,
          children: opportunity.title
        }), /*#__PURE__*/_jsxs(LogoContainer, {
          children: [/*#__PURE__*/_jsx(Link, {
            href: "organisation_view",
            params: {
              slug: opportunity.organisation.slug
            },
            children: /*#__PURE__*/_jsx(OrgAvatar, {
              width: "100px",
              src: opportunity.organisation.logo.thumb
            })
          }), /*#__PURE__*/_jsx(Link, {
            sx: {
              textDecoration: 'none'
            },
            href: "organisation_view",
            params: {
              slug: opportunity.organisation.slug
            },
            children: /*#__PURE__*/_jsx(Typography, {
              variant: "body1",
              children: opportunity.organisation.name
            })
          })]
        }), /*#__PURE__*/_jsx(Grid, {
          container: true,
          children: /*#__PURE__*/_jsx(Grid, {
            item: true,
            xs: 12,
            sm: 12,
            children: loading ? /*#__PURE__*/_jsx(_Fragment, {
              children: Array.from(new Array(3)).map(function () {
                return /*#__PURE__*/_jsx(Box, {
                  marginTop: "0.5rem",
                  marginBottom: "0.5rem",
                  children: /*#__PURE__*/_jsx(Skeleton, {
                    animation: "wave",
                    variant: "rect",
                    height: 27,
                    width: "50%"
                  })
                });
              })
            }) : /*#__PURE__*/_jsxs(Box, {
              children: [opportunity.types && opportunity.types.length > 0 && /*#__PURE__*/_jsxs(OpportunityMeta, {
                variant: "body1",
                children: [/*#__PURE__*/_jsx(LibraryMusicIcon, {}), opportunity.types.map(function (type, i) {
                  return i === 0 ? type.name : ", ".concat(type.name);
                })]
              }), opportunity.is_virtual || opportunity.is_worldwide ? /*#__PURE__*/_jsxs(_Fragment, {
                children: [opportunity.is_virtual && /*#__PURE__*/_jsxs(OpportunityMeta, {
                  variant: "body1",
                  children: [/*#__PURE__*/_jsx(LanguageIcon, {}), t('common:virtual_opportunity')]
                }), opportunity.is_worldwide && /*#__PURE__*/_jsxs(OpportunityMeta, {
                  variant: "body1",
                  children: [/*#__PURE__*/_jsx(PublicIcon, {}), t('common:worldwide_opportunity')]
                })]
              }) : opportunity.location && /*#__PURE__*/_jsxs(OpportunityMeta, {
                variant: "body1",
                children: [/*#__PURE__*/_jsx(RoomIcon, {}), opportunity.location.formatted_address]
              }), /*#__PURE__*/_jsxs(ActionsContainer, {
                children: [/*#__PURE__*/_jsx(Divider, {}), userCanApply() && (!(opportunity !== null && opportunity !== void 0 && opportunity.opp_status) || (opportunity === null || opportunity === void 0 ? void 0 : opportunity.opp_status) === OPP_STATUS_ENUM.PUBLISHED || (opportunity === null || opportunity === void 0 ? void 0 : opportunity.opp_status) === OPP_STATUS_ENUM.ACTIVE) && /*#__PURE__*/_jsxs(_Fragment, {
                  children: [/*#__PURE__*/_jsxs(Fab, {
                    className: "applyButton",
                    variant: "extended",
                    fullWidth: true,
                    startIcon: /*#__PURE__*/_jsx(AssignmentTurnedInIcon, {}),
                    color: "primary",
                    size: "large",
                    disabled: !isAvailableFees,
                    onClick: applyPageHandler,
                    style: {
                      padding: "1.75rem 1.5rem",
                      borderRadius: "30px"
                    },
                    children: [/*#__PURE__*/_jsx(AssignmentTurnedInOutlinedIcon, {}), /*#__PURE__*/_jsx(Spacer, {
                      width: "0.5rem"
                    }), isAvailableFees ? t('common:apply') : 'Sold Out']
                  }), /*#__PURE__*/_jsx(Spacer, {
                    width: "1rem",
                    height: "1rem"
                  })]
                }), isMobile && /*#__PURE__*/_jsx(Divider, {})]
              }), opportunity.deadline_date && /*#__PURE__*/_jsxs(DedaLine, {
                variant: "body1",
                children: [/*#__PURE__*/_jsx(AccessAlarmsIcon, {}), "".concat(t('common:deadline'), ": ").concat(moment(opportunity.deadline_date).format("".concat((_opportunity$time_vis = opportunity.time_visibility) !== null && _opportunity$time_vis !== void 0 && _opportunity$time_vis.deadline_time ? 'DD MMM YYYY  HH:mm' : 'D MMM YYYY')))]
              })]
            })
          })
        })]
      }), loading ? /*#__PURE__*/_jsx(_Fragment, {
        children: Array.from(new Array(10)).map(function () {
          return /*#__PURE__*/_jsx(Box, {
            width: "100%",
            marginBottom: "1.5rem",
            children: /*#__PURE__*/_jsx(Skeleton, {
              animation: "wave",
              variant: "rect",
              height: 30,
              width: "100%"
            })
          });
        })
      }) : /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsxs(BodyText, {
          children: [/*#__PURE__*/_jsx(Typography, {
            variant: "h5",
            weight: "700",
            children: t('common:description')
          }), /*#__PURE__*/_jsx(Spacer, {
            height: "1rem"
          }), /*#__PURE__*/_jsx(Typography, {
            variant: "body1",
            style: {
              wordBreak: 'break-word',
              whiteSpace: 'break-spaces'
            },
            children: opportunity.description
          }), /*#__PURE__*/_jsxs(ShareBox, {
            children: [/*#__PURE__*/_jsx(Typography, {
              variant: "overline",
              gutterBottom: true,
              color: "secondary",
              children: t('opportunity:share')
            }), /*#__PURE__*/_jsx(InstapaperShareButton, {
              url: "https://mubazar.com/".concat(i18n.language, "/opportunity/").concat(slug),
              children: /*#__PURE__*/_jsx(InstagramIcon, {
                color: "primary"
              })
            }), /*#__PURE__*/_jsx(TwitterShareButton, {
              url: "https://mubazar.com/".concat(i18n.language, "/opportunity/").concat(slug),
              children: /*#__PURE__*/_jsx(TwitterIcon, {
                color: "primary"
              })
            }), /*#__PURE__*/_jsxs(FacebookShareButton, {
              url: "https://mubazar.com/".concat(i18n.language, "/opportunity/").concat(slug),
              children: [' ', /*#__PURE__*/_jsx(FacebookIcon, {
                color: "primary"
              })]
            }), /*#__PURE__*/_jsx(LinkedinShareButton, {
              url: "https://mubazar.com/".concat(i18n.language, "/opportunity/").concat(slug),
              children: /*#__PURE__*/_jsx(LinkedInIcon, {
                color: "primary"
              })
            })]
          }), /*#__PURE__*/_jsx(SectionDivider, {})]
        }), /*#__PURE__*/_jsxs(BodyText, {
          children: [/*#__PURE__*/_jsx(Typography, {
            variant: "overline",
            weight: "600",
            color: "primary",
            children: t('target')
          }), /*#__PURE__*/_jsx(Typography, {
            variant: "h4",
            children: t(opportunity.target.toLowerCase())
          }), /*#__PURE__*/_jsx(Spacer, {
            height: "1rem"
          }), /*#__PURE__*/_jsx(Typography, {
            variant: "overline",
            weight: "600",
            color: "primary",
            children: t('age_limit')
          }), /*#__PURE__*/_jsx(Typography, {
            variant: "h4",
            children: opportunity.max_age ? "".concat(opportunity.min_age || 0, " - ").concat(opportunity.max_age) : t('common:all_ages')
          }), /*#__PURE__*/_jsx(Spacer, {
            height: "1rem"
          }), (opportunity.experience_level || ((_opportunity$experien = opportunity.experience_level) === null || _opportunity$experien === void 0 ? void 0 : _opportunity$experien.length) > 0) && /*#__PURE__*/_jsxs(_Fragment, {
            children: [/*#__PURE__*/_jsx(Typography, {
              variant: "overline",
              weight: "600",
              color: "primary",
              children: t('experience')
            }), /*#__PURE__*/_jsx(Typography, {
              variant: "h4",
              children: formatExperienceLevel(opportunity.experience_level)
            })]
          })]
        }), /*#__PURE__*/_jsx(Spacer, {
          height: "1rem"
        }), opportunity.target_countries.length > 0 && /*#__PURE__*/_jsxs(BodyText, {
          children: [/*#__PURE__*/_jsx(OpportunityMeta, {
            variant: "h5",
            weight: "700",
            gutterBottom: true,
            children: t('wizard:open_to_following_countries')
          }), /*#__PURE__*/_jsx(ChipsContainer, {
            children: opportunity.target_countries.map(function (country) {
              return /*#__PURE__*/_jsx(StyledChip, {
                variant: "outlined",
                label: country.name
              }, country.id);
            })
          }), /*#__PURE__*/_jsx(Spacer, {
            height: "1rem"
          })]
        }), opportunity.genres.length > 0 && /*#__PURE__*/_jsxs(BodyText, {
          children: [/*#__PURE__*/_jsx(OpportunityMeta, {
            variant: "h5",
            weight: "700",
            gutterBottom: true,
            children: t('common:genres')
          }), /*#__PURE__*/_jsx(ChipsContainer, {
            children: opportunity.genres.map(function (genre) {
              return /*#__PURE__*/_jsx(StyledChip, {
                variant: "outlined",
                label: genre.name === 'all' ? t('common:all') : capitalize(genre.name)
              }, genre.id);
            })
          }), /*#__PURE__*/_jsx(Spacer, {
            height: "1rem"
          })]
        }), opportunity.instruments.length > 0 && /*#__PURE__*/_jsxs(BodyText, {
          children: [/*#__PURE__*/_jsx(OpportunityMeta, {
            variant: "h5",
            weight: "700",
            gutterBottom: true,
            children: t('common:instruments')
          }), /*#__PURE__*/_jsx(ChipsContainer, {
            children: opportunity.instruments.map(function (instrument) {
              return /*#__PURE__*/_jsx(StyledChip, {
                variant: "outlined",
                label: instrument.name === 'all' ? t('common:all') : capitalize(instrument.name)
              }, instrument.id);
            })
          }), /*#__PURE__*/_jsx(Spacer, {
            height: "1rem"
          })]
        }), opportunity.languages.length > 0 && /*#__PURE__*/_jsxs(BodyText, {
          children: [/*#__PURE__*/_jsx(OpportunityMeta, {
            variant: "h5",
            weight: "700",
            gutterBottom: true,
            children: t('common:languages')
          }), /*#__PURE__*/_jsx(ChipsContainer, {
            children: opportunity.languages.map(function (language) {
              return /*#__PURE__*/_jsx(StyledChip, {
                variant: "outlined",
                label: language.name === 'all' ? t('common:all') : capitalize(language.name)
              }, language.id);
            })
          }), /*#__PURE__*/_jsx(Spacer, {
            height: "1rem"
          })]
        }), /*#__PURE__*/_jsx(Spacer, {
          height: "1rem"
        }), /*#__PURE__*/_jsxs(BodyText, {
          children: [opportunity.payment_details && opportunity.payment_details.length > 0 && /*#__PURE__*/_jsx(Grid, {
            item: true,
            xs: 12,
            children: /*#__PURE__*/_jsx(OpportunityMeta, {
              variant: "h5",
              weight: "700",
              color: "secondary",
              gutterBottom: true,
              children: t('wizard:fee_type.opportunity_cost')
            })
          }), opportunity.payment_details && opportunity.payment_details.length > 0 && opportunity.payment_details.map(function (fee) {
            return /*#__PURE__*/_jsx(OpportunityFee, _objectSpread({}, fee));
          })]
        }), opportunity.video_links && opportunity.video_links.length > 0 && opportunity.video_links[0] !== null && /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(BodyText, {
            children: /*#__PURE__*/_jsx(OpportunityMeta, {
              variant: "h5",
              weight: "700",
              gutterBottom: true,
              children: t('common:videos')
            })
          }), opportunity.video_links.length === 1 ? /*#__PURE__*/_jsx(VideoItem, {
            width: 350,
            value: opportunity.video_links[0]
          }) : /*#__PURE__*/_jsx(VideoSlider, {
            videos: opportunity.video_links
          })]
        }), /*#__PURE__*/_jsx(Spacer, {
          height: "2rem"
        }), /*#__PURE__*/_jsx(BodyText, {
          children: opportunity.gallery.length > 0 && /*#__PURE__*/_jsxs(_Fragment, {
            children: [/*#__PURE__*/_jsx(OpportunityMeta, {
              variant: "h5",
              weight: "700",
              gutterBottom: true,
              children: t('Images')
            }), /*#__PURE__*/_jsx(ImageLightbox
            // thmubsSize="160px"
            , {
              images: getImagesArray(opportunity.gallery, 'path')
            })]
          })
        }), /*#__PURE__*/_jsx(Spacer, {
          height: "2rem"
        })]
      })]
    })
  });
};
ViewOpportunity.defaultProps = {
  opportunity: null
};
export default ViewOpportunity;